import 'twin.macro'
import React from 'react'

import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useListenUserProfileQuery } from 'modules/Users/userApi'
import { useListenStripeProductIdQuery } from 'modules/ProductInfo/productInfoApi'

import Loading from 'modules/App/components/Loading'
import ProductLayout from 'modules/ProductInfo/layouts/ProductLayout'
import CheckoutPageBuilder from './CheckoutPageBuilder'

export default function CheckoutPageBuilderSubs() {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''
  const { data: stripeProductId } = useListenStripeProductIdQuery({ coachOrgId })
  const stripeProductIdLoading = stripeProductId === undefined || stripeProductId?.isLoading

  if (stripeProductIdLoading) {
    return (
      <ProductLayout>
        <div className='mt-12 max-w-[90rem] bg-white rounded-xl p-8 border-2 border-gray-200'>
          <Loading showHeader={false} containerClasses='!bg-white' />
        </div>
      </ProductLayout>
    )
  }
  return (
    <ProductLayout>
      <CheckoutPageBuilder />
    </ProductLayout>
  )
}
